import type { QuantityProps } from "@components/ngg";
import { Quantity } from "@components/ngg";
import type { CartItem } from "@server/gql/graphql";
import { MinusIcon, PlusIcon } from "lucide-react";

import { cn } from "@/lib/utils";

import { isCheckoutDisabled } from "../Stock/Stock.utils";

export default function Action({
  item,
  update,
  prefix,
  loading,
  className,
  classNames,
}: {
  item: CartItem;
  update: (item: CartItem) => void;
  prefix?: string;
  loading?: boolean;
  className?: string;
  classNames?: QuantityProps["classNames"];
}) {
  return (
    <div className={cn("flex items-center lg:justify-self-end", className)}>
      {prefix && <span className="mr-2 text-sm uppercase">{prefix}:</span>}
      <Quantity
        dense
        readOnly
        disabled={loading}
        value={item.quantity}
        onIncrease={() =>
          isCheckoutDisabled(item)
            ? null
            : update({
                ...item,
                quantity: item.quantity + 1,
              })
        }
        onDecrease={() =>
          update({
            ...item,
            quantity: item.quantity - 1,
          })
        }
        DecreaseIcon={<MinusIcon strokeWidth={1} className="size-4" />}
        IncreaseIcon={<PlusIcon strokeWidth={1} className="size-4" />}
        className="border-gray-200"
        classNames={{
          decreaseButton: cn(
            "flex basis-1/3 items-center justify-center text-sm",
            classNames?.decreaseButton,
          ),
          increaseButton: cn(
            "flex basis-1/3 items-center justify-center text-sm",
            classNames?.increaseButton,
            isCheckoutDisabled(item) && "cursor-not-allowed opacity-50",
          ),
          wrapper: cn(
            "border-x-1 h-5 max-w-16 divide-x border-gray-150 text-sm child:border-gray-150 lg:h-8 lg:max-w-24",
            classNames?.wrapper,
          ),
          input: cn("basis-1/3 text-sm", classNames?.input),
        }}
      />
    </div>
  );
}
